import { render, staticRenderFns } from "./GridBasicTaskTemplate.vue?vue&type=template&id=710cc9ae&scoped=true&"
import script from "./GridBasicTaskTemplate.vue?vue&type=script&lang=js&"
export * from "./GridBasicTaskTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GridBasicTaskTemplate.vue?vue&type=style&index=0&id=710cc9ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710cc9ae",
  null
  
)

export default component.exports